// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_fg-3";
export var flatBottomCorners = "_fg-5";
export var productImage = "_fg-0";
export var quantityContainer = "_fg-2";
export var quantityHeader = "_fg-6";
export var tooltip = "_fg-1";
export var wrapAndEllipsesOverflow = "_fg-4";